import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-67" data-mp="3f2n5jtmhckow">
      {eyebrow && <p className={`text-xs font-extrabold uppercase tracking-[0.18em] ${dark ? "text-gold" : "text-gold-dark"}`} data-id="element-68" data-mp="3jzdocopo5ue0">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 font-serif text-[30px] font-black leading-[1.1] md:text-5xl ${dark ? "text-white" : "text-navy"}`} data-id="element-69" data-mp="bmpwjo021is5">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-[17px] leading-relaxed md:text-lg ${dark ? "text-white/75" : "text-navy/70"}`} data-id="element-70" data-mp="6tn9lyps97kx">
          {intro}
        </p>}
    </div>;
}